import React from 'react';
import FormStringsDescriptionWrapper from './FormStringsDescriptionWrapper';

const FormStringsDescription = ({ canEdit, showEdit, text }) => (
  <FormStringsDescriptionWrapper canEdit={canEdit} showEdit={showEdit} text={text} />
);

export default FormStringsDescription;
